import axios from 'axios';

function authHeaders() {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
}

// The public read is shared by the home page and the login/register pages (which hide their
// "Back to Landing" link while the home page is switched off). Kept as long as the server caches
// it, so going from `/` to `/login` and back doesn't fetch again or flash the dark page.
const PUBLIC_CACHE_MS = 60 * 1000;
let publicCache = { at: 0, data: null, pending: null };

const clearPublicCache = () => { publicCache = { at: 0, data: null, pending: null }; };

// Public home page (Sprint 7 "Home Template"). Content is edited by SuperAdmin.
const landingPageAPI = {
  // Public: content plus upcoming job fairs, employers and organizations.
  // `{ enabled: false }` and nothing else while SuperAdmin has switched the page off.
  async getPublic() {
    if (publicCache.data && Date.now() - publicCache.at < PUBLIC_CACHE_MS) return publicCache.data;
    if (!publicCache.pending) {
      publicCache.pending = axios.get('/api/landing-page')
        .then((response) => {
          publicCache = { at: Date.now(), data: response.data, pending: null };
          return response.data;
        })
        .catch((error) => {
          publicCache.pending = null;
          throw error;
        });
    }
    return publicCache.pending;
  },

  // The cached public read if it's still fresh, else null. Lets a page decide on first render.
  peekPublic() {
    return publicCache.data && Date.now() - publicCache.at < PUBLIC_CACHE_MS ? publicCache.data : null;
  },

  // SuperAdmin: the editable content
  async getContent() {
    const response = await axios.get('/api/landing-page/content', { headers: authHeaders() });
    return response.data;
  },

  // SuperAdmin: save. A 400 carries `errors: [{ field, message }]`.
  async saveContent(content) {
    const response = await axios.put('/api/landing-page/content', { content }, { headers: authHeaders() });
    clearPublicCache();
    return response.data;
  },

  // SuperAdmin: go back to the default content
  async resetContent() {
    const response = await axios.delete('/api/landing-page/content', { headers: authHeaders() });
    clearPublicCache();
    return response.data;
  },

  // SuperAdmin: switch the public home page on or off. Off sends `/` to the login page.
  async setEnabled(enabled) {
    const response = await axios.put('/api/landing-page/enabled', { enabled }, { headers: authHeaders() });
    clearPublicCache();
    return response.data;
  },

  clearPublicCache
};

export default landingPageAPI;
